import React, { ChangeEvent, memo } from 'react'
import styled from 'styled-components'

import InputHeaderRow from 'components/Input/InputHeaderRow'
import NumericInput from 'components/Input/NumericInput'
import InputTitle from 'components/Input/InputTitle'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { setDesireMode, setOrderSize, setOrderTotal } from 'state/exchange/reducer'
import {
  selectCurrentMarketInfo,
  selectOrderDirection,
  selectOrderPrice,
  selectOrderSize,
  selectOrderTotal,
  selectOrderType
} from 'state/exchange/selectors'
import { OrderDirection } from '@bitly/sdk/types'

type MarginInputProps = {
	isMobile?: boolean
}

const AmountInput: React.FC<MarginInputProps> = memo(({ isMobile }) => {
	const dispatch = useAppDispatch()
	const size = useAppSelector(selectOrderSize)
	const marketInfo = useAppSelector(selectCurrentMarketInfo)
	const orderDirection = useAppSelector(selectOrderDirection)

	const onChangeValue = (_: ChangeEvent<HTMLInputElement>, v: string) => {
		dispatch(setOrderSize(v))
		dispatch(setDesireMode(orderDirection === OrderDirection.sell ? false : true))
	}

	return (
		<>
			<InputHeaderRow
				label={
					<StyledInputTitle>
						Amount ({marketInfo?.tokenX.symbol})
					</StyledInputTitle>
				}
			></InputHeaderRow>

			<NumericInput
				dataTestId={'set-order-margin-susd' + (isMobile ? '-mobile' : '-desktop')}
				value={size}
				placeholder="0.00"
				right={false}
				onChange={onChangeValue}
			/>
		</>
	)
})

const StyledInputTitle = styled(InputTitle)`
	text-transform: capitalize;
`

export default AmountInput
